import React from 'react';
import PropTypes from 'prop-types';
import { Breadcrumbs, Crumb } from 'components/core/Breadcrumbs';

export default function FacilityBreadcrumbs({
	facility,
	baseUrl,
	crumbs = [],
	...rest
}) {
	const computedCrumbs = facility.name
		? [
				<Crumb
					key="facility"
					label={facility.name}
					to={facility.url}
					isLast={!crumbs.length}
				/>,
				...crumbs,
			]
		: crumbs;

	return (
		<Breadcrumbs
			{...rest}
			location={facility.seoLocation}
			cityUrl={facility.cityUrl}
			stateUrl={facility.stateUrl}
			baseUrl={baseUrl}
			crumbs={computedCrumbs}
		/>
	);
}

FacilityBreadcrumbs.propTypes = {
	facility: PropTypes.shape({
		name: PropTypes.string,
		url: PropTypes.string,
		seoLocation: PropTypes.object,
		cityUrl: PropTypes.string,
		stateUrl: PropTypes.string,
	}).isRequired,
	baseUrl: PropTypes.string,
	crumbs: PropTypes.array,
};
